import { render, staticRenderFns } from "./EditGuestSpecificRights.vue?vue&type=template&id=8d5eb412&"
import script from "./EditGuestSpecificRights.vue?vue&type=script&lang=js&"
export * from "./EditGuestSpecificRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports